import { SortableMultiSelectField } from "@app/lib/form";
import {
  Component,
  Field,
  HasMany,
  HasOne,
  StaticRender,
} from "@contember/interface";
import { CaseStudyPreview } from "../previews/case-study-preview";
import { PrimaryLocale } from "../primary-locale";
import { BlockHeadline } from "./blockHeadline";

export const CaseStudiesForm = Component(() => (
  <>
    <BlockHeadline />
    <SortableMultiSelectField
      field="caseStudies"
      label="Highlighted case studies"
      connectAt="caseStudy"
      sortableBy="displayOrder"
    >
      <PrimaryLocale>
        <CaseStudyPreview />
      </PrimaryLocale>

      <StaticRender>
        <PrimaryLocale>
          <Field field="link.url" />
          <Field field="title" />
          <Field field="leadText" />
          <Field field="revenue" />
        </PrimaryLocale>

        <HasOne field="logo">
          <Field field="url" />
          <Field field="alt" />
        </HasOne>
        <HasMany field="tags">
          <PrimaryLocale>
            <Field field="name" />
          </PrimaryLocale>
        </HasMany>
        <HasMany field="products">
          <HasOne field="product">
            <PrimaryLocale>
              <Field field="name" />
            </PrimaryLocale>
          </HasOne>
        </HasMany>
        <HasMany field="solutions">
          <HasOne field="solution">
            <PrimaryLocale>
              <Field field="name" />
            </PrimaryLocale>
          </HasOne>
        </HasMany>
      </StaticRender>
    </SortableMultiSelectField>
    <div className="text-sm bg-teal-100 p-2 rounded-md text-teal-500">
      If any highlighted studies are selected, the highlighted studies
      will be shown first, the rest of the them will be shown
      after the selected ones.
    </div>
  </>
));
